import type { PartSvgProps } from './types'

export default function AkHandguardLowerSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  width = 200,
  height = 70
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 200 70" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="12" width="192" height="50" rx="6"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      <rect x="40" y="28" width="30" height="24" rx="2" fill="#0A0D14" />
      <rect x="90" y="28" width="30" height="24" rx="2" fill="#0A0D14" />
      <rect x="140" y="28" width="30" height="24" rx="2" fill="#0A0D14" />
    </svg>
  )
}
